export default "__VITE_ASSET__DUEz6tqQ__"